import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import * as React from "react";

export interface SearchFieldWrapperStyles {
    wrapper?: GridItemProps;
}

export const searchFieldWrapperStyles: SearchFieldWrapperStyles = {};

const SearchFieldWrapper: React.FC<React.PropsWithChildren<{ extendedStyles?: SearchFieldWrapperStyles }>> = ({
    children,
    extendedStyles,
}) => {
    const styles = mergeToNew(searchFieldWrapperStyles, extendedStyles);
    return <GridItem {...styles.wrapper}>{children}</GridItem>;
};

export default SearchFieldWrapper;
